module.exports = __webpack_public_path__ + "5b762eb3.svg";